import "client-only";

export type SessionRevocationAccountKind = "customer" | "staff";
export const sessionRevocationWarningText = "Your password changed, but session cleanup or revocation of other sessions was not confirmed. Sign in with your new password, then review Account security and use Revoke other sessions.";
const warningKey = (kind: SessionRevocationAccountKind) => `vintera.session-revocation-review.${kind}`;

// Presentation state only. It carries no account identity, credential or authority.
export function rememberSessionRevocationWarning(kind: SessionRevocationAccountKind, storage?: Storage) {
  try { (storage ?? window.sessionStorage).setItem(warningKey(kind), "pending"); return true; } catch { return false; }
}

export function hasSessionRevocationWarning(kind: SessionRevocationAccountKind, storage?: Storage) {
  try { return (storage ?? window.sessionStorage).getItem(warningKey(kind)) === "pending"; } catch { return false; }
}

export function acknowledgeSessionRevocationWarning(kind: SessionRevocationAccountKind, storage?: Storage) {
  try { (storage ?? window.sessionStorage).removeItem(warningKey(kind)); } catch { /* No security authority is affected. */ }
}
